import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function HairProfessionalLevel2() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    Hair Professional Level 2 Apprenticeship
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    ST0213 - Begin Your Hairdressing Career
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content Section */}
        <section id="hair-professional-level-2" className="hair-professional section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>

                  {/* Introduction */}
                  <div className="mb-5">
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The Hairdressing Apprenticeship Level 2 is available for any learner above the age of 16 and there are no entry requirements for this apprenticeship.
                    </p>
                    
                    <div className="mb-4 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                      <p style={{ color: '#495057', fontSize: '1.05rem', fontWeight: '600', marginBottom: 0 }}>
                        <span style={{ color: '#7B3F9E' }}>Duration:</span> 18 - 24 months, on average.
                      </p>
                    </div>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      During your apprenticeship you will be earning a wage while learning your skills. An apprentice will be employed in a salon for a minimum of 30 hours per week and will be entitled to all working benefits.
                    </p>
                  </div>

                  {/* The Qualification */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      The Qualification
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      During the apprenticeship you will be assessed on your knowledge and understanding of the five mandatory units and one optional unit. These assessments will be completed by your DTK assessor to the requirements of the awarding body.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      Apprentices will be working towards the Hair Professionals Standard Hairdressing Apprenticeship and after completing the program you will be fully qualified stylist with options to further your education with other apprenticeships.
                    </p>
                  </div>

                  {/* Job Titles */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Job titles include
                    </h4>
                    
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                      gap: '15px',
                      marginBottom: '20px'
                    }}>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        textAlign: 'center'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1rem', fontWeight: '500', marginBottom: 0 }}>
                          Hair professional
                        </p>
                      </div>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        textAlign: 'center'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1rem', fontWeight: '500', marginBottom: 0 }}>
                          Hair stylist
                        </p>
                      </div>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        textAlign: 'center'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1rem', fontWeight: '500', marginBottom: 0 }}>
                          Hairdresser
                        </p>
                      </div>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        textAlign: 'center'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1rem', fontWeight: '500', marginBottom: 0 }}>
                          Stylist
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* What Will I Be Doing In My First Year? */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      What Will I Be Doing in My First Year?
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      A 1st year apprentice hairdresser typically performs tasks such as shampooing, conditioning, and blow-drying hair, as well as assisting senior hairdressers with cutting, colouring, and styling. You may also be responsible for maintaining the cleanliness and organisation of the salon, interacting with clients, and following established safety and sanitary procedures. Throughout your apprenticeship, you are expected to develop your skills and knowledge through hands-on experience and training under the guidance of senior, experienced hairdressers.
                    </p>
                  </div>

                  {/* Occupation Duties */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Occupation duties
                    </h4>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px' }}>
                      <li style={{ marginBottom: '10px' }}>Provide a positive impression of yourself, organisation and the hairdressing industry.</li>
                      <li style={{ marginBottom: '10px' }}>Adhere to health and safety, infection control, legal, industry and organisational requirements, industry protocols and manufacturer instructions.</li>
                      <li style={{ marginBottom: '10px' }}>Advise, consult, examine and analyse the hair, skin and scalp.</li>
                      <li style={{ marginBottom: '10px' }}>Shampoo, condition and treat hair and scalp.</li>
                      <li style={{ marginBottom: '10px' }}>Cut hair using a range of techniques to create a variety of looks.</li>
                      <li style={{ marginBottom: '10px' }}>Style, set, dress and finish hair using a variety of techniques to create a variety of looks.</li>
                      <li style={{ marginBottom: '10px' }}>Change the hair classification type by one classification using chemical services</li>
                      <li style={{ marginBottom: '10px' }}>Perform a range of chemical services to change the colour depth and tone.</li>
                      <li style={{ marginBottom: '10px' }}>Use, apply and recommend a range of products, tools and equipment for a range of services.</li>
                      <li>Maintain up to date knowledge and skills of new and emerging hairstyles, trends, techniques, products, tools and equipment.</li>
                    </ul>
                  </div>

                  {/* Assessment Information */}
                  <div className="mb-5">
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      Observations and knowledge tests will be used to assess skills, knowledge and behaviours required for the Level 2 Diploma for Hair Professionals.
                    </p>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      All students are required to purchase a practical kit and uniform, details of which will be provided during your advice and guidance discussion and induction.
                    </p>
                  </div>

                  {/* How The Apprenticeship Works */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      How The Apprenticeship Works
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      DTK Apprenticeships provide outstanding hairdressing apprenticeships where you can complete the apprenticeship through with a tri-work route where all the training end assessments are completed in your own salon.
                    </p>

                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px', marginBottom: '15px' }}>
                      <li style={{ marginBottom: '10px' }}>Regular Progress Reviews throughout the apprenticeship allowing you to offer feedback on your training.</li>
                      <li style={{ marginBottom: '10px' }}>End Point Assessment preparation and support.</li>
                      <li>Full support for your English and maths functional skills using specially developed tools and materials.</li>
                    </ul>
                  </div>

                  {/* Completing The Apprenticeship */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Completing The Apprenticeship
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      At the end of your hairdressing apprenticeship, after you have successfully completed the unit assessments, you will receive a Certificate of Unit Achievement. This allows you to progress onto the Gateway stage of the apprenticeship.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      The Gateway is a period where we will review your knowledge, skills and behaviours to see if you have met the minimum requirements and are ready to take the End Point Assessment.
                    </p>
                  </div>

                  {/* What is the End Point Assessment (EPA)? */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      What is the End Point Assessment (EPA)?
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The EPA is an assessment of all the knowledge, skills and behaviours you have learned throughout your apprenticeship.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The EPA gateway is when the EPAO checks and confirms that you have met any requirements required before you start the EPA. The EPA period is typically 3 months.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px', fontWeight: '600' }}>
                      The gateway requirements for your EPA are:
                    </p>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px', marginBottom: '15px' }}>
                      <li style={{ marginBottom: '10px' }}>achieved English and mathematics qualifications through on-line tests in line with the apprenticeship funding rules</li>
                      <li style={{ marginBottom: '10px' }}>for the professional discussion, underpinned by a portfolio of evidence, you must submit a portfolio of evidence</li>
                      <li>passed any other qualifications listed in the occupational standard</li>
                    </ul>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      After you have passed all the elements of the EPA, you will receive your apprenticeship certificate.
                    </p>
                  </div>

                  {/* EPA Details */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#e7f3ff', border: '1px solid #b3d9ff', borderRadius: '12px' }}>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The EPA will consist of observation and questioning whilst working on 2 models and will last a maximum of 6.5 hours.
                    </p>

                    <h5 style={{ color: '#0066cc', fontSize: '1.3rem', fontWeight: '600', marginBottom: '15px' }}>
                      Multiple-choice test
                    </h5>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px' }}>
                      You will complete a multiple-choice test. It will be closed book, meaning you will not have access to any books or reference materials. The test will have 40 multiple-choice questions. You will have 60 minutes to complete it.
                    </p>

                    <h5 style={{ color: '#0066cc', fontSize: '1.3rem', fontWeight: '600', marginBottom: '15px' }}>
                      Practical assessment with questions
                    </h5>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px' }}>
                      You will be observed by an independent assessor completing a set of tasks. It will last 5.5 hours. They will ask you at least 3 questions.
                    </p>

                    <h5 style={{ color: '#0066cc', fontSize: '1.3rem', fontWeight: '600', marginBottom: '15px' }}>
                      Professional discussion underpinned by a portfolio of evidence
                    </h5>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      You will have a professional discussion with an independent assessor. It will last 35 minutes. They will ask you at least 6 questions. The questions will be about certain aspects of your occupation. You need to compile a portfolio of evidence before the EPA gateway. You can use it to help answer the questions.
                    </p>
                  </div>

                  {/* Qualification Requirements */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      For the hairdressing professional, the qualification required is:
                    </h4>
                    
                    <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                      <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0 }}>
                        TQUK Level 2 Diploma for Hair Professionals (Hairdressing) (RQF) 603/3101/X or
                      </p>
                    </div>
                    
                    <div className="p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                      <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0 }}>
                        VTCT Skills Level 2 Diploma for Hair Professionals (Hairdressing) 603/1323/7
                      </p>
                    </div>
                  </div>

                  {/* What Does the Future Hold? */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      What Does the Future Hold?
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      After you have completed your Hair Professionals Standard Hairdressing Apprenticeship you will be a fully qualified hairdresser and will be able to work independently within your salon.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      The natural progression for a level 2 qualified hairdresser is to continue onto the Advanced and Creative Hairdressing Apprenticeship Level 3.
                    </p>
                  </div>

                  {/* What Next? */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      What Next?
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      If you are interested in strengthening your team or enhancing their skills, please visit us to learn more about the resources and support we offer.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      If you are seeking to further develop your own skills and expertise, email us.
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default HairProfessionalLevel2;